class AbstractStorageProvider {
  store;
  constructor(store) {
    this.store = store;
  }
}
export {
  AbstractStorageProvider
};
//# sourceMappingURL=AbstractStorageProvider.js.map
